import axios from 'axios';
import Alert from 'components/Alert';
import { constants } from 'helpers/constants';
import React from 'react';
import ProductTypes from 'store/Orbita/Product/types';

export default class Alumy {
  static isAlumy = (partnerId: number) => partnerId === constants.productPartners.alumy;

  static alumyModal = async () => {
    const confirm = await Alert.confirm({
      message: 'Essa configuração deve ser feita na Alumy. Deseja continuar?',
      title: 'Produto Alumy',
      confirmation: true,
      buttonOk: <>Ir para alumy</>,
      buttonCancel: <>Cancelar</>,
    });

    if (confirm) Alumy.openAlumy();
  };

  static alumyModalDelivery = async () => {
    const confirm = await Alert.confirm({
      message: 'Para realizar esse tipo de entrega você deve acessar a tela de membros da Alumy',
      title: 'Acesse a Alumy',
      confirmation: true,
      buttonOk: <>Ir para alumy</>,
      buttonCancel: <>Cancelar</>,
    });

    if (confirm) Alumy.openAlumy();
  };

  static openAlumy = () => window.open('https://alumy.com/login', '_blank');

  static alumyProductDelivery = (id: number, email: string) => ProductTypes.productDelivery.createAction(() => Alumy.productDelivery(id, email));

  private static productDelivery(id: number, emailCustomer: string) {
    let data = JSON.stringify({ email: emailCustomer, cnt_cod: id });

    return axios.request({
      method: 'post',
      url: 'https://api.alumy.com/v1/partner/enrollments/resend',
      headers: {
        token: '7a695def38331fc23119960b2e55440952b55542',
        'Content-Type': 'application/json',
      },
      data,
    });
  }
}
